import React, { useEffect } from "react";
import PhoneHeader from "../../Components/Common/PhoneHeader";
import { connect } from "react-redux";
import Chart from "../../Components/UsageManagement/Chart";
import { CompanyImage } from "../../Components/Payment/BillInquire";
import { useHistory } from "react-router-dom";
const ChartPage = ({ chartInfo, isLogin }) => {
  const history = useHistory();
  const standalone = window.matchMedia("(display-mode: standalone)").matches;
  useEffect(() => {
    if (standalone) {
      history.push("/addtohome");
    } else if (!isLogin) {
      history.push("/login");
    }
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    (window.orientation == 90 || window.orientation == -90) &&
      isMobile &&
      history.push("/rotate");
    window.addEventListener(
      "orientationchange",
      function () {
        var isForbidden =
          (window.orientation == 90 || window.orientation == -90) && isMobile;
        if (isForbidden) {
          history.push("/rotate");
        }
      },
      false
    );
  }, []);
  return (
    <div className="Container">
      <div
        className="mobileContainer"
        style={{ paddingTop: window.innerHeight * 0.12 }}
      >
        <PhoneHeader text={"مدیریت مصرف"} />
        <div className="ChartPage">
          <span id="ChartSpan">{`نمودار مصرف مربوط به ${chartInfo.billId}`}</span>
          <img src={CompanyImage(chartInfo.companyId)} id="companyImage" />
          <Chart data={chartInfo.chartData} />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    chartInfo: state.auth.chartInfo,
    isLogin: state.auth.isLogin,
  };
};

export default connect(mapStateToProps)(ChartPage);
